const preencheInfo = (state, action)=>{ 
    //UseReducer -> um useState  porém com inumeras variaveis e funções, no caso esse para 
    //cadastro de produtos
    switch(action.type){
        case "for_cod":
            return{
                ...state,
                for_cod: action.value
            };
        case "item_cod":
            return{
                ...state,
                item_cod: action.value
            };
        case "dadosBd":
            return{
                ...state,
                dadosBd: action.value
            };
        case "showFiltroEstoque":
            return{
                ...state,
                showFiltroEstoque: action.value
            };
        case "atualizaEstoque":
            return{
                ...state,
                atualizaEstoque: action.value
            };
        case "codRevista":
            return{
                ...state,
                codRevista: action.value
            };
        case "pagina":
            return{
                ...state,
                pagina: action.value
            };   
        case "alerta":
            return{
                ...state,
                alerta: action.value
            }; 
        case "ultimaAtt":
            return{
                ...state,
                ultimaAtt: action.value
            }; 
        case "resvistaList":
            return{
                ...state,
                resvistaList: action.value
            }; 
        case "carregando":
            return{
                ...state,
                carregando: action.value
            }; 
        case "limpar":
            return{
                ...state,
                limpar: action.value
            }; 
            
        default: 
            return;
        }
    }
    
export default preencheInfo;